import React from 'react';
import { cn } from '@/lib/utils';

export const Input = React.forwardRef(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={cn(
      'w-full bg-transparent border border-white/20 px-4 h-11 text-white placeholder:text-white/30',
      'focus:border-volt focus:ring-1 focus:ring-volt focus:outline-none transition-colors',
      'rounded-none font-body',
      className,
    )}
    {...props}
  />
));
Input.displayName = 'Input';

export const Textarea = React.forwardRef(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      'w-full bg-transparent border border-white/20 px-4 py-3 text-white placeholder:text-white/30 min-h-[88px]',
      'focus:border-volt focus:ring-1 focus:ring-volt focus:outline-none transition-colors rounded-none font-body',
      className,
    )}
    {...props}
  />
));
Textarea.displayName = 'Textarea';

export const Label = ({ className, ...props }) => (
  <label className={cn('block text-xs font-bold uppercase tracking-[0.2em] text-white/60 mb-2', className)} {...props} />
);

export const Field = ({ label, htmlFor, error, children, hint }) => (
  <div className="space-y-1.5">
    {label && <Label htmlFor={htmlFor}>{label}</Label>}
    {children}
    {hint && !error && <p className="text-xs text-white/40">{hint}</p>}
    {error && <p className="text-xs text-[#FF3B30] uppercase tracking-wider">{error}</p>}
  </div>
);
